import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";

function RequestApproval() {
  const { data } = UseGetDashBoardData(`/dashboard/request-approvals`);

  return (
    <div className="bg-gray-50/60 p-3.5 rounded-xl border border-gray-100 flex flex-col justify-between">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700">Requests</span>
        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200/50">
          {data?.total || 0} Total
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2 mt-1">
        <div className="flex flex-col p-1.5 rounded-lg bg-amber-50/60 text-left">
          <span className="text-[10px] text-amber-700 font-medium">Pending</span>
          <span className="text-xs font-bold text-gray-800">{data?.pendding || "0"}</span>
        </div>

        <div className="flex flex-col p-1.5 rounded-lg bg-emerald-50/60 text-left">
          <span className="text-[10px] text-emerald-700 font-medium">Approved</span>
          <span className="text-xs font-bold text-gray-800">{data?.approved || "0"}</span>
        </div>
      </div>
    </div>
  );
}

export default RequestApproval;